import React, { useState, useRef } from "react";
import Nav from "./components/Nav/Nav";
import Hero from "./components/Hero/Hero";
import About from "./components/About/About";
import Skills from "./components/Skills/Skills";
import Experience from "./components/Experience/Experience";
import useOnScreen from "./hooks/useOnScreen";
import "./index.css";

function App() {
  // State for modal
  const [modalData, setModalData] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  const [isRendered, setIsRendered] = useState(false); // For rendering the modal

  // Refs for visibility tracking
  const experienceRef = useRef(null);
  const skillsRef = useRef(null);
  const aboutRef = useRef(null);

  const isExperienceVisible = useOnScreen(experienceRef);
  const isSkillsVisible = useOnScreen(skillsRef);
  const isAboutVisible = useOnScreen(aboutRef);

  const openModal = (data) => {
    setModalData(data);
    setIsRendered(true);
    setTimeout(() => {
      setIsModalOpen(true); // Add `show` class after rendering
    }, 10);
    setIsClosing(false);
  };

  const closeModal = () => {
    setIsClosing(true);
    setTimeout(() => {
      setModalData(null);
      setIsModalOpen(false);
      setIsRendered(false); // Remove modal from DOM
      setIsClosing(false);
    }, 600);
  };

  return (
    <div className="app">
      <Nav />
      <div id="home">
        <Hero />
      </div>

      <div
        id="experience"
        ref={experienceRef}
        className={isExperienceVisible ? "component-visible" : "component-hidden"}
      >
        <Experience openModal={openModal} />
      </div>

      <div
        id="skills"
        ref={skillsRef}
        className={isSkillsVisible ? "component-visible" : "component-hidden"}
      >
        <Skills />
      </div>

      <div
        id="about"
        ref={aboutRef}
        className={isAboutVisible ? "component-visible" : "component-hidden"}
      >
        <About />
      </div>

      {/* Global Modal */}
      {isRendered && (
        <div
          className={`modalOverlay ${isModalOpen ? "show" : ""} ${
            isClosing ? "closing" : ""
          }`}
          onClick={closeModal}
        >
          <div className="modalContent" onClick={(e) => e.stopPropagation()}>
            <button className="closeButton" onClick={closeModal}>
              &times;
            </button>
            <h2>{modalData?.title}</h2>
            {modalData?.date && <h3>{modalData?.date}</h3>}
            <p>{modalData?.description}</p>
            <div className="modalTechnologies">
              {modalData?.technologies.map((tech, idx) => (
                <span key={idx} className="techBadge">
                  {tech}
                </span>
              ))}
            </div>
            {modalData?.link && (
              <a
                href={modalData.link}
                target="_blank"
                rel="noopener noreferrer"
                className="modalLink"
              >
                View Project
              </a>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
